module.exports = __webpack_public_path__ + "img/tv2.58bc7347.gif";